'use es6';

import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import GreaterThanRolling from 'customer-data-filters/filterQueryFormat/operator/GreaterThanRolling';
import I18n from 'I18n';
import LessThanRolling from 'customer-data-filters/filterQueryFormat/operator/LessThanRolling';
import PropTypes from 'prop-types';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UISelect from 'UIComponents/input/UISelect';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorRollingWithUnitInput = props => {
  const {
    className,
    error,
    onChange,
    onBlur,
    value
  } = props;
  const handleChangeDirection = ({
    target: {
      value: direction
    }
  }) => onChange(SyntheticEvent(value.set('direction', direction)));
  const handleChangeValue = ({
    target: {
      value: time
    }
  }) => onChange(SyntheticEvent(value.merge({
    direction: value.direction || 'backward',
    value: time,
    timeUnit: value.timeUnit || 'days'
  })));
  const handleChangeTimeUnit = ({
    target: {
      value: timeUnit
    }
  }) => onChange(SyntheticEvent(value.set('timeUnit', timeUnit)));
  const directionOptions = [{
    text: I18n.text('customerDataFilters.FilterEditorOperatorRollingUnitInput.directionOptionLabelBackward'),
    value: 'backward'
  }, {
    text: I18n.text('customerDataFilters.FilterEditorOperatorRollingUnitInput.directionOptionLabelForward'),
    value: 'forward'
  }];
  const unitOptions = [{
    text: I18n.text('customerDataFilters.FilterEditorOperatorRollingUnitInput.days'),
    value: 'days'
  }, {
    text: I18n.text('customerDataFilters.FilterEditorOperatorRollingUnitInput.weeks'),
    value: 'weeks'
  }];
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "baseline",
    className: className,
    children: /*#__PURE__*/_jsxs(UIInputGroup, {
      "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: error.error,
      use: "none",
      validationMessage: error.error ? error.message : null,
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
        error: error.error,
        children: /*#__PURE__*/_jsx(UINumberInput, {
          defaultValue: 1,
          min: 1,
          onBlur: onBlur,
          onChange: handleChangeValue,
          value: value.value
        })
      }), /*#__PURE__*/_jsx(UISelect, {
        buttonUse: "unstyled",
        className: "m-left-2",
        defaultValue: "days",
        onChange: handleChangeTimeUnit,
        options: unitOptions,
        value: value.timeUnit
      }), /*#__PURE__*/_jsx(UISelect, {
        buttonUse: "unstyled",
        className: "m-left-2",
        defaultValue: "backward",
        onChange: handleChangeDirection,
        options: directionOptions,
        value: value.direction
      })]
    })
  });
};
FilterOperatorRollingWithUnitInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(GreaterThanRolling).isRequired, PropTypes.instanceOf(LessThanRolling).isRequired]).isRequired
};
export default FilterOperatorRollingWithUnitInput;